export enum AcademicTitle {
  NONE = 'none',
  DR = 'dr',
  PROF = 'prof',
  PROF_DR = 'prof-dr',
}
